import React, { PureComponent } from 'react';
import Header from './Header';
import { hot } from 'react-hot-loader';
import ErrorBoundary from 'core/components/ErrorBoundary';
import ResponsiveProvider from 'core/providers/ResponsiveProvider';

class HeaderContainer extends PureComponent {
	render () {
		return (
			<ErrorBoundary>
				<ResponsiveProvider>
					<Header {...this.props} />
				</ResponsiveProvider>
			</ErrorBoundary>
		);
	}
}

export default hot(module)(HeaderContainer);
